 const colorMap = new Map([
      ['Red Shine',["#bf2a52",false]],
      ['Beige Shine',["#b86061",false]],
      ['Crimson Silk',["#cf3f48",false]],
      ['Nude Sensation',["#993e4b",false]],
      ['Mulberry Feast',["#9c316b",false]],
      ['Peach Fizz',["#b9444c",false]],
      ['Fuchsia Pink',["#8e1732",false]],
      ['Brown Sugar',["#381d1b",false]],
      ['Cocoa',["#4a1613",false]],
      ['Vintage Red',["#791119",false]],
      ['Mulberry Wine',["#270d0d",false]],
      ['Fiery Red',["#75141c",false]],
      ['Walnut Praline',["#43221f",false]],
      ['Nut Roast',["#4d1b1e",false]],
      ['Beachy Vibe',["#6b2f33",false]],
      ['Sweet Praline',["#733538",false]],
      ['Tropical Princess',["#5a1f1f",false]],
      ['Bold In Red',["#51191e",false]],
      ['SP2 Pink Dream',["#ca4767",false]],
      ['SB2 Coffee Queen',["#9d5041",false]],
      ['SR1 Retro Red',["#b52a2b",false]],
      ['SM1 Blush Mauve',["#af5859",false]],
      ['SP3 Pink Flamingo',["#df6b6c",false]],
      ['SR5 Wine',["#a24e60",false]],
      ['SP1 Pink Rose',["#e64972",false]],
      ['SR4 Ruby Red',["#da414b",false]],
      ['SB1 Chocolate Brown',["#6f4040",false]],
      ['SN2 Peachy Vibe',["#e26f60",false]],
      ['SR2 Burnt Red',["#d34e51",false]],
      ['SN3 Sand Nude',["#d37252",false]],
      ['SR3 Red Pop',["#e23b38",false]],
      ['SN1 Lush Nude',["#de7a50",false]],
      ['Warm Creme',["#c8936c",false]],
      ['Warm Beige',["#d29c6c",false]],
      ['Cool Rose',["#c2845e",false]],
      ['Neutral Nude',["#be946e",false]],
      ['Warm Natural',["#c08e66",false]],
      ['Neutral Medium',["#cc956a",false]],
      ['Warm Sand',["#cb946f",false]],
      ['C300 Cool Cinnamon',["#d39a6f",false]],
      ['N360 Neutral Chestnut',["#bf8659",false]],
      ['C380 Cool Walnut',["#cb956f",false]],
      ['N340 Neutral Almond',["#c0906c",false]],
      ['Pink Rouge',["#d56e71",false]],
      ['Salty Caramel',["#cb8267",false]],
      ['Pink Watermelon',["#f36e65",false]],
      ['Salmon Pink',["#e1686d",false]],
      ['Brick Brown',["#d86d63",false]],
      ['Apricot Rust',["#e97865",false]],
      ['Natural',["#cdad96",false]],
      ['Honey',["#b6927f",false]],
      ['Sand',["#c4a38e",false]],
      ['Almond',["#ae7c63",false]],
      ['Dynamic Purple',["#4F023A",false]],
      ['Crisp Wine',["#8F042C",false]],
      ['Intense Latte',["#954038",false]],
      ['Magenta Rhythm',["#7a1c43",false]],
      ['Indie Maroon',["#a01522",false]],
      ['Red Boots',["#a53333",false]],
      ['Red Letter',["#de2b31",false]],
      ['Red Coat',["#da0533",false]],
      ['Red Rust',["#8c2f23",false]],
      ['Berry Base',["#902e3b",false]],
      ['Coral Date',["#e36058",false]],
      ['Pink Perfect',["#e82c5f",false]],
      ['Ruby Rush',["#d82f4e",false]],
      ['Pink Party',["#8b4651",false]],
      ['Plum Pink',["#bc2263",false]],
      ['Maroon Mix',["#913446",false]],
      ['Blushing Nude',["#cd7170",false]],
      ['Rosy Sunday',["#903d45",false]],
      ['Nude Touch',["#a85f55",false]],
      ['Mauve Matter',["#aa5b67",false]],
      ['Garnet Punch',["#714157",false]],
      ['Sangria Weekend',["#713d3d",false]],
      ['Deep Wine',["#790427",false]],
      ['Roseatte Red',["#a64244",false]],
      ['Chocolate Crush',["#835056",false]],
      ['Caramel Latte',["#ac573f",false]],
      ['Red Twist',["#d50e16",false]],
      ['Burgundy Passion',["#80001e",false]],
      ['Pink Rose',["#db1d3e",false]],
      ['Blush Pink',["#e95d6f",false]],
      ['Dusty Pink',["#a26769",false]],
      ['Peachy Affair',["#d84c54",false]],
      ['Rose Day',["#b01645",false]],
      ['Brown Walnut',["#75433c",false]],
      ['Rustic Brown',["#924930",false]],
      ['Coffee Command',["#96554f",false]],
      ['Scarlet Surge',["#db284e",false]],
      ['Cherry Chic',["#962d33",false]],
      ['Brick Blush',["#cc503c",false]],
      ['Iconic Red',["#c6153c",false]],
      ['Red Velvet',["#831033",false]],
      ['Morning Coffee',["#a3605b",false]],
      ['Black Currant',["#56272b",false]],
      ['Golden Hour',["#cb8c78",false]],
      ['Mauve Petal',["#9F4047",false]],
      ['Pink Peach',["#af4047",false]],
      ['Red Wine',["#822346",false]],
      ['Mauve Party',["#6e3c3d",false]],
      ['Crimson Rose',["#73161e",false]],
      ['Nude Pink',["#944654",false]],
      ['Mysterious Black',["#111113",false]],
      ['Ethereal White',["#eae6de",false]],
      ['Alluring Silver',["#85878b",false]],
      ['Fearless Brown',["#bc6a6a",false]],
      ['Retro Red',["#9d140f",false]],
      ['Ruby Red',["#ba0114",false]],
      ['White',["#e8e6e6",false]],
      ['Shimmering Gold',["#efb815",false]],
      ['Sunset Gold',["#f5a46f",false]],
      ['Red Siren',["#da3038",false]],
      ['Brown Chili',["#cd4538",false]],
      ['Pink Passion',["#fd0233",false]],
      ['C380 Cool Walnut',["#b6916b",false]],
      ['302 Cocoa Sin',["#884d45",false]],
      ['102 Crimson Sky',["#b12233",false]],
      ['103 Nude Brick',["#b2534c",false]],
      ['101 Nude Dream',["#da626b",false]],
      ['301 Red Dare',["#7d2e2b",false]],
      ['201 Pink Party',["#e0556a",false]],
      ['303 Red Alert',["#b0372d",false]],
      ['202 Pink Play',["#b03640",false]],
      ['304 Red Blast',["#c73f2f",false]],
      ['204 Pink Bae',["#ed5e63",false]],
      ['104 Nude Flair',["#db7253",false]],
      ['Shimmering Silver',["#bfc1c7",false]],
      ['Sand',["#bd8e6e",false]],
      ['Walnut',["#af8165",false]],
      ['Cinnamon',["#c48c66",false]],
      ['Cocoa',["#83624d",false]],
      ['Beige',["#bd8e70",false]],
      ['Coffee Lite',["#a05349",false]],
      ['Rose Touch',["#ab5059",false]],
      ['Deep Wine',["#790427",false]],
      ['Rosy Sunday',["#903d45",false]],
      ['Nude Touch',["#a85f55",false]],
      ['Pink Rose',["#db1d3e",false]],
      ['Beige',["#C7936E",false]],
      ['Cocoa',["#885A45",false]],
      ['Walnut',["#9A705A",false]],
      ['Romeo Red',["#d31646",false]],
      ['Night Diva',["#cf8177",false]],
      ['Day Queen',["#e0aa90",false]],
      ['Orange',["#fa8e74",false]],
      ['Green',["#b4dcc1",false]],
      ['Purple',["#c1b0d2",false]],
      ['Smokey Diva',["#a7a7a7",false]],
      ['Nude Bomb',["#e3687e",false]],
      ['Golden Hour Goddess',["#be7356",false]],
      ['Pink Beauty',["#de97a0",false]],
      ['Copper',["#be867d",false]],
      ['Magenta',["#967b9d",false]],
      ['Bronze',["#c6966f",false]],
      ['Blue',["#7c819d",false]],
      ['Gold',["#b58f4c",false]],
      ['Champagne',["#a88b7e",false]],
      ['Pink',["#b06b8e",false]],
      ['Red',["#d27a80",false]],
      ['Turquoise',["#4d8689",false]],
      ['Mint',["#9eacaf",false]],
      ['Warm Creme',["#d9b186",false]],
      ['Cool Ivory',["#deac90",false]],
      ['Warm Natural',["#d7ad89",false]],
      ['Warm Beige',["#e1ae7f",false]],
      ['Neutral Medium',["#dfac83",false]],
      ['Neutral Almond',["#e2ad86",false]],
      ['Define Diva-Neutral Light',["#ca9b7b",false]],
      ['Bold Drama-Neutral Medium',["#c89982",false]],
      ['Sunlit Sepia',["#f1d4be",false]],
      ['Golden Gleam',["#f2d5c1",false]],
      ['Grapevine Goddess',["#ac657d",false]],
      ['Silver Shimmer bomb',["#ebebed",false]],
      ['Blushing Nude',["#f4a68e",false]],
      ['Pink Powerhouse',["#f0a3a2",false]],
      ['Coral Queen',["#d78770",false]],
      ['Sweet Cheeks',["#e897ae",false]],
      ['Cherry Bomb',["#eb433e",false]],
      ['Warm Creme',["#d9b186",false]],
      ['Cool Ivory',["#deac90",false]],
      ['Warm Natural',["#d7ad89",false]],
      ['Warm Beige',["#e1ae7f",false]],
      ['Neutral Medium',["#dfac83",false]],
      ['Neutral Almond',["#e2ad86",false]],
      ['Ivory Fair 12g',["#e2cba5",false]],
      ['Golden Sand 12g',["#dbb18f",false]],
      ['Rose Fair 12g',["#e6b68e",false]],
      ['Beige Honey 12g',["#d5a981",false]],
      ['Love struck Red',["#a0333f",false]],
      ['The One Red',["#9f2a25",false]],
      ['Love Me Red',["#812731",false]],
      ['Rebound Red',["#bc3336",false]],
      ['New Flame Red',["#a82424",false]],
      ['Right Swipe Pink',["#c1224e",false]],
      ['Perfect Match Pink',["#da2d4c",false]],
      ['Sweet heart Pink',["#e05960",false]],
      ['Passion Pink',["#de5049",false]],
      ['First Crush Pink',["#c65d6c",false]],
      ['Date Night Pink',["#935057",false]],
      ['Lets Talk Nude',["#9c4549",false]],
      ['Blush Nude',["#aa605e",false]],
      ['Bare Nude',["#985949",false]],
      ['Copper Crush',["#f4b296",false]],
      ['Sultry Gold',["#efd3ab",false]],
      ['Soft Coral',["#f87266",false]],
      ['Pink Rose',["#eb3c65",false]],
      ['Default Title',["#e2d5d0",false]],
      ['103 Red Rose',["#c33a30",false]],
      ['102 Red Ruby',["#c1190f",false]],
      ['101 Red Rage',["#fa0001",false]],
      ['104 Maroon Magnet',["#b23944",false]],
      ['203 Fuchsia Fun',["#ff4a98",false]],
      ['202 Pink Plum',["#c2525b",false]],
      ['201 Pink Power',["#dc2d54",false]],
      ['302 Nude Nectar',["#be5a5d",false]],
      ['301 Brown Beauty',["#894330",false]],
      ['502 Purple Pop',["#7d3d54",false]],
      ['501 Burgundy Boss',["#a12e53",false]],
      ['401 Orange Oasis',["#f3340b",false]],
      ['Pink Ruby',["#e13761",false]],
      ['Red Wine',["#a43d4c",false]],
      ['Pink Date',["#b85455",false]],
      ['Nude Toast',["#a25c5f",false]],
      ['Warm Sand',["#cb946f",false]],
      ['Warm Beige',["#d29c6c",false]],
      ['Warm Creme',["#c8936c",false]],
      ['Warm Natural',["#c08e66",false]],
      ['Brown',["#71524f",false]],
      ['Deep Brown',["#63483d",false]],
      ['Bronze H1',["#e88d78",false]],
      ['Gold H2',["#fd9d6a",false]],
      ['Rose Gold H3',["#ff8a78",false]],
      ['Natural Rose B1',["#f83b46",false]],
      ['Flushed Pink B2',["#e5416d",false]],
      ['Perfect Plum B3',["#ce3f62",false]],
      ['Peppy Peach B4',["#ff2d4a",false]],
      ['Black',["#000000",false]],
      ['Nude Nectar',["#e04b32",false]],
      ['Purple Hue',["#870d34",false]],
      ['Pink Berry',["#dc3b5c",false]],
      ['Pink Rose',["#eb636d",false]],
      ['Downtown Nude',["#d93b5f",false]],
      ['Pretty Pink',["#d46469",false]],
      ['Deep Red',["#dc2c2e",false]],
      ['Fiery Red',["#ed3831",false]],
      ['C100 Cool Ivory',["#d1a989",false]],
      ['W160 Warm Sand',["#e4ab8c",false]],
      ['N200 Neutral Nude',["#d0997c",false]],
      ['W240 Warm Beige',["#d5a379",false]],
      ['C300 Cool Cinnamon',["#d2997a",false]],
      ['C380 Cool Walnut',["#b6916b",false]],
      ['Shimmering Silver',["#bfc1c7",false]],
      ['Brilliantly Bronze',["#e69f6c",false]],
      ['Bedazzled Brown',["#bf8163",false]],
      ['Dreamy RosÃ©',["#e5b3a6",false]],
      ['Glittering Gold Dust',["#f1ca75",false]],
      ['Magenta Muse',["#c6788f",false]],
      ['Champagne Rain',["#d2b9a7",false]],
      ['Darling Blue',["#10b4d9",false]],
      ['Invincible Purple',["#c479b1",false]],
      ['Vibrant Azure',["#4abebc",false]],
      ['Etheral White',["#ececec",false]],
      ['Fearless Brown',["#bc6a6a",false]],
      ['Pearl Play',["#c4bca8",false]],
      ['Glam Grey',["#aa9369",false]],
      ['Silver Dust',["#aeabac",false]],
      ['Golden Glow',["#c9ad78",false]],
      ['Dusty Gold',["#d0a64e",false]],
      ['Champagne Brown',["#cc937b",false]],
      ['Copper Burst',["#f0a664",false]],
      ['Blushing Pink',["#e296a5",false]],
      ['Berry Blush',["#dc7372",false]],
      ['Peachy Play',["#eb9465",false]],
      ['Electric Peach',["#ea8159",false]],
      ['Lavender Glam',["#b892b8",false]],
      ['Retro Red',["#9d140f",false]],
      ['Red Pop',["#b50102",false]],
      ['Ruby Red',["#ba0114",false]],
      ['Wine',["#6a1d2d",false]],
      ['Pink Rose',["#a1012d",false]],
      ['Pink Dream',["#a6082d",false]],
      ['Peachy Vibe',["#ed7369",false]],
      ['Sand Nude',["#862401",false]],
      ['Coffee Queen',["#742516",false]],
      ['Blush Mauve',["#722224",false]],
      ['Brown',["#986a62",false]],
      [' MINIS',["#c86b76",false]],
      [' MINIS',["#a50102",false]],
      ['Black',["#252728",false]],
      ['Red Royale',["#94313e",false]],
      ['Pink Charm',["#e53a64",false]],
      ['Brown Burst',["#b24d3f",false]],
      ['Red Bombshell',["#fd081e",false]],
      ['Mauve Spice',["#c34c5b",false]],
      ['Mauve Love',["#a2355f",false]],
      ['Brown Chili',["#cd4538",false]],
      ['Pink Passion',["#fd0233",false]],
      ['Brown Buzz',["#bc2630",false]],
      ['Red Siren',["#da3038",false]],
      ['Ivory',["#e7b996",false]],
      ['Sand',["#bd8e6e",false]],
      ['Beige',["#bd8e70",false]],
      ['Cinnamon',["#c48c66",false]],
      ['Walnut',["#af8165",false]],
      ['Cocoa',["#83624d",false]],
      ['Blush Nude',["#db6765",false]],
      ['Pink Rouge',["#d56e71",false]],
      ['Salmon Pink',["#e1686d",false]],
      ['Brick Brown',["#d86d63",false]],
      ['Pink Punch',["#cd5f60",false]],
      ['Salty Caramel',["#cb8267",false]],
      ['Cinnamon Spice',["#843522",false]],
      ['Red Sienna',["#d55b38",false]],
      ['Default Title',["#f36e65",false]],
      ['Default Title',["#e97865",false]],
      ['Gray',["#989a9a",false]],
      ['Black',["#000000",false]],
      ['Sparkling Olive',["#38553d",false]],
      ['Liquid Gold',["#635931",false]],
      ['Shimmer Bronze',["#794b3d",false]],
      ['Rose',["#6e262c",false]],
      ['Passion Pink',["#ad0212",false]],
      ['Fuchsia Pink',["#8e1732",false]],
      ['Beachy Vibe',["#6b2f33",false]],
      ['Nut Roast',["#4d1b1e",false]],
      ['Walnut Praline',["#43221f",false]],
      ['Tropical Princess',["#5a1f1f",false]],
      ['Sweet Praline',["#733538",false]],
      ['Salted Caramel',["#78423d",false]],
      ['Cocoa',["#4a1613",false]],
      ['Brown Sugar',["#381d1b",false]],
      ['Mulberry Wine',["#270d0d",false]],
      ['SR1 Retro Red',["#b52a2b",false]],
      ['SR2 Burnt Red',["#d34e51",false]],
      ['SR3 Red Pop',["#e23b38",false]],
      ['SR4 Ruby Red',["#da414b",false]],
      ['SP1 Pink Rose',["#e64972",false]],
      ['SP2 Pink Dream',["#ca4767",false]],
      ['SP3 Pink Flamingo',["#df6b6c",false]],
      ['SN1 Lush Nude',["#de7a50",false]],
      ['SN2 Peachy Vibe',["#e26f60",false]],
      ['SN3 Sand Nude',["#d37252",false]],
      ['SB1 Chocolate Brown',["#6f4040",false]],
      ['SB2 Coffee Queen',["#9d5041",false]],
      ['SM1 Blush Mauve',["#af5859",false]],
      ['SN4 Caramel Latte',["#a65e3a",false]],
      ['SR5 Wine',["#a24e60",false]],
      ['Warm Creme',["#c8936c",false]],
      ['Cool Ivory',["#d9a480",false]],
      ['Warm Natural',["#c08e66",false]],
      ['Neutral Nude',["#be946e",false]],
      ['Warm Beige',["#d29c6c",false]],
      ['Warm Sand',["#cb946f",false]],
      ['Neutral Medium',["#cc956a",false]],
      ['Cool Rose',["#c2845e",false]],
      ['Black',["#050505",false]],
      ['Black',["#000000",false]],
      ['Sparkling Black',["#474747",false]],
      ['Default Title',["#e8e6e6",false]],
      ['Forest Green',["#58533f",false]],
      ['Turquoise',["#0e5f66",false]],
      ['Regal Green',["#283b39",false]],
      ['Royal Blue',["#144b60",false]],
      ['Classic Brown',["#48342b",false]],
      ['Midnight Blue',["#18588e",false]],
      ['Cherry Love',["#C82B4E",false]],
      ['Pink Floss',["#D1326A",false]],
      ['Pink Parfait',["#E07086",false]],
      ['Brown Sheer',["#984C4B",false]],
      ['Rose Wood',["#690B10",false]],
      ['Nude Charm',["#A34F53",false]],
      ['Red Berry',["#C01A4E",false]],
      ['Red Candy',["#BB334E",false]],
      ['Mauve Petal',["#9F4047",false]],
      ['Rich Mahogany',["#774669",false]],
      ['Brown Espresso',["#603b35",false]],
      ['Coral Candy',["#d34052",false]],
      ['Coral Sense',["#bc5352",false]],
      ['Crimson Rose',["#73161e",false]],
      ['Fuschia Chic',["#9b3d61",false]],
      ['Mauve Ecstasy',["#824354",false]],
      ['Mauve Fling',["#8f4f67",false]],
      ['Mauve Party',["#6e3c3d",false]],
      ['Nude Dream',["#803a3a",false]],
      ['Nude Hue',["#aa6865",false]],
      ['Nude Latte',["#b26a59",false]],
      ['Nude Myth',["#af5f54",false]],
      ['Nude Pink',["#944654",false]],
      ['Nude Twist',["#834536",false]],
      ['Orange Tango',["#c95440",false]],
      ['Pink Ballet',["#b65c64",false]],
      ['Pink Glam',["#a0384f",false]],
      ['Pink Peach',["#af4047",false]],
      ['Pink Prom',["#e7387d",false]],
      ['Pink Punch',["#b04862",false]],
      ['Pink Trip',["#a63d77",false]],
      ['Purple Pout',["#842e55",false]],
      ['Red Carpet',["#b22430",false]],
      ['Red Cherry',["#7b150a",false]],
      ['Red Revival',["#9a101f",false]],
      ['Red Sangria',["#751d2d",false]],
      ['Red Velvet',["#ad2936",false]],
      ['Red Wine',["#822346",false]],
      ['Wine Glow',["#7a2350",false]],
      ['Wine Touch',["#5c2125",false]],
      ['Pink Salt',["#d24449",false]],
      ['Pink Venus',["#b96969",false]],
      ['Red Divine',["#8a2747",false]],
      ['Red Drive',["#e32429",false]],
      ['Nude Perk',["#b76f5d",false]],
      ['Nude Bloom',["#a56062",false]],
      ['Pink Vintage',["#e36161",false]],
      ['Brown Vixen',["#7b4468",false]],
      ['Pink Dusk',["#975058",false]],
      ['Red Icon',["#c16c7d",false]],
      ['Pink Salt',["#d24449",false]],
      ['Pink Venus',["#b96969",false]],
      ['Red Divine',["#8a2747",false]],
      ['Red Drive',["#e32429",false]],
      ['Nude Perk',["#b76f5d",false]],
      ['Nude Bloom',["#a56062",false]],
      ['Pink Vintage',["#e36161",false]],
      ['Brown Vixen',["#7b4468",false]],
      ['Pink Dusk',["#975058",false]],
      ['Red Icon',["#c16c7d",false]],
      ['112 Princess',["#ef8a98",false]],
      ['113 Pink Fever',["#e33341",false]],
      ['114 Fireball',["#dd2226",false]],
      ['115 Tinkerbell',["#849638",false]],
      ['116 Mistletoe',["#236b5c",false]],
      ['117 Silver Lining',["#bbb7b2",false]],
      ['118 Champagne Sparkle',["#d3a267",false]],
      ['119 Amethyst',["#764a7a",false]],
      ['120 Ocean Eyes',["#4e94bb",false]],
      ['121 Icicle',["#a6cdd7",false]],
      ['206 Pink Flush',["#cf2f7c",false]],
      ['301 Red Dare',["#7d2e2b",false]],
      ['302 Red Rebel',["#d73d38",false]],
      ['303 Red Alert',["#b0372d",false]],
      ['304 Red Blast',["#c73f2f",false]],
      ['101 Nude Dream',["#da626b",false]],
      ['102 Nude Rose',["#c56b69",false]],
      ['103 Nude Brick',["#b2534c",false]],
      ['104 Nude Flair',["#db7253",false]],
      ['105 Pink Slay',["#ab5653",false]],
      ['201 Pink Party',["#e0556a",false]],
      ['202 Pink Play',["#b03640",false]],
      ['203 Pink Femme',["#c15a70",false]],
      ['204 Pink Bae',["#ed5e63",false]],
      ['205 Pink Wine',["#944746",false]],
      ['Spice Note',["#925248",false]],
      ['Mauve Passion',["#874E66",false]],
      ['Nude Sparkle',["#8D4D40",false]],
      ['Cosmos Blush',["#9E3D64",false]],
      ['Rich Wine',["#744A5B",false]],
      ['Strawberry Pie',["#8B284B",false]],
      ['Pink Sparkle',["#B3476B",false]],
      ['Rosewood Forest',["#8A554E",false]],
      ['Go Grape',["#6a2b3c",false]],
      ['Black Currant',["#56272b",false]],
      ['Cocoa Fudge',["#5b2623",false]],
      ['Natural Marble',["#fdd1ae",false]],
      ['Natural Coral',["#fad3ba",false]],
      ['Natural Pearl',["#fed1bc",false]],
      ['Natural Shell',["#fcd2ba",false]],
      ['Ntural Beigea',["#e1a37b",false]],
      ['Natural Cinnamon',["#d19256",false]],
      ['Marble',["#e3b192",false]],
      ['Pearl',["#ea9c76",false]],
      ['Shell',["#e79e70",false]],
      ['Coral',["#e79e70",false]],
      ['Beige',["#d1a065",false]],
      ['Cinnamon',["#c9955d",false]],
      ['Crush 14',["#5d656b",false]],
      ['Crush 16',["#6b233d",false]],
      ['Crush 90',["#d1e474",false]],
      ['Crush 91',["#3a726d",false]],
      ['Crush 13',["#aad3d5",false]],
      ['Crush 71',["#d5b7d6",false]],
      ['Crush 81',["#ef8178",false]],
      ['Crush 82',["#c0756e",false]],
      ['Crush 108',["#8e2a44",false]],
      ['Crush 10',["#f7f7f7",false]],
      ['Crush 11',["#934d57",false]],
      ['Crush 15',["#f5f2ec",false]],
      ['Crush 48',["#f79482",false]],
      ['Crush 18',["#e5627a",false]],
      ['Crush 19',["#ff756d",false]],
      ['Crush 20',["#f2a9b4",false]],
      ['Crush 21',["#eb4771",false]],
      ['Crush 22',["#b44750",false]],
      ['Crush 24',["#d13a49",false]],
      ['Crush 25',["#962c37",false]],
      ['Crush 27',["#268daf",false]],
      ['Crush 31',["#f02331",false]],
      ['Crush 36',["#f296b2",false]],
      ['Crush 42',["#e4866e",false]],
      ['Crush 43',["#df7481",false]],
      ['Crush 67',["#272b2c",false]],
      ['Crush 102',["#871b22",false]],
      ['Crush 103',["#8f656f",false]],
      ['Crush 202',["#995a54",false]],
      ['Crush 236',["#a24868",false]],
      ['Crush 237',["#d76353",false]],
      ['Crush 238',["#d1835c",false]],
      ['Crush 401',["#a02b35",false]],
      ['Crush 403',["#6f1c4b",false]],
      ['Crush 404',["#a60002",false]],
      ['Crush 415',["#ad1d27",false]],
      ['Crush 416',["#950304",false]],
      ['Crush 417',["#84153f",false]],
      ['Crush 501',["#fe3b3c",false]],
      ['Crush 504',["#f7737e",false]],
      ['Crush 505',["#d13d3a",false]],
      ['Crush 506',["#d84d83",false]],
      ['Crush 525',["#9c4142",false]],
      ['Berry Business',["#8b3549",false]],
      ['Blue Scape',["#aaccd8",false]],
      ['Blush Punch',["#f1535e",false]],
      ['Caramel Case',["#7a4731",false]],
      ['Indigo Ink',["#3c6a9e",false]],
      ['Lilac Link',["#9d72a0",false]],
      ['Lime Treat',["#b5ba5c",false]],
      ['Magenta Mix',["#bb3e64",false]],
      ['Mulberry Bush',["#722f3a",false]],
      ['Mustard Master',["#d8a347",false]],
      ['Pink Pace',["#d45781",false]],
      ['Red Alert',["#7d373e",false]],
      ['Ruby Rush',["#9a3a45",false]],
      ['Salmon Strike',["#e97b7c",false]],
      ['Teal Deal',["#48817a",false]],
      ['Woody Desk',["#5e3727",false]],
      ['Nude Flush',["#c5877a",false]],
      ['Orange Coat',["#e77374",false]],
      ['Cherry Red',["#e04f2c",false]],
      ['Peach Blossom',["#d87a73",false]],
      ['Pink Paisley',["#cd8288",false]],
      ['Olive Green',["#69795d",false]],
      ['Purple Haze',["#63335a",false]],
      ['Clay Grey',["#676e7c",false]],
      ['Scarlet Blaze',["#81263A",false]],
      ['Top_Coat_2',["#48817a",false]],
      ['Russian Mauve',["#6270a7",false]],
      ['Lush Lavender',["#9886bc",false]],
      ['Perky Pink',["#c71833",false]],
      ['Marble White',["#f4f0eb",false]],
      ['Minty Green',["#cee7cc",false]],
      ['Smokey Crimson',["#58081a",false]],
      ['Staycation Nude',["#ba765f",false]],
      ['Apple Blossom',["#b48784",false]],
      ['Candy Peach',["#f7a095",false]],
      ['301 Nude Sensation',["#d77576",false]],
      ['302 Cocoa Sin',["#884d45",false]],
      ['101 Scarlet Siren',["#e63d3e",false]],
      ['303 Nude Naturalle',["#d97574",false]],
      ['304 Chocolate Temptation',["#8c403d",false]],
      ['201 Purple Haze',["#d84978",false]],
      ['202 Pink Veil',["#b9676c",false]],
      ['102 Crimson Sky',["#b12233",false]],
      ['203 Plum Punch',["#bd204f",false]],
      ['103 Dark Cherry',["#5b1739",false]],
      ['204 Fuchsia Fantasy',["#e47d94",false]],
      ['205 Mauve Mischief',["#a4264a",false]],
      ['Blue Orchid',["#06548b",false]],
      ['Sunset Gold',["#f5a46f",false]],
      ['Hawaian Pink',["#dd88a1",false]],
      ['Subtle Pink',["#f4a2a7",false]],
      ['Aquamarine',["#27765c",false]],
      ['Umber',["#2f2324",false]],
      ['Champagne',["#bc877e",false]],
      ['Default Title',["#efb815",false]],
      ['Jaded Grey',["#8f7769",false]],
      ['Almond',["#b46b36",false]],
      ['Frappe',["#e59560",false]],
      ['Bronze',["#d08a5e",false]],
      ['Beige',["#fcc492",false]],
      ['Pink Lady',["#eda2c7",false]],
      ['Dusty Rose',["#b1656a",false]],
      ['Vintage Romance',["#a25369",false]],
      ['Salmon Souffle',["#ee2c30",false]],
      ['Lobster Love',["#ed3e20",false]],
      ['Road Trip',["#323542",false]],
      ['Cool Cobalt',["#323542",false]],
      ['Pearl',["#fcc1ae",false]],
      ['Baby Blue',["#abcde8",false]],
      ['Summer Mint',["#91d3c4",false]],
      ['Perfect Pistachio',["#9fcb91",false]],
      ['Azure Waters',["#3c6d9f",false]],
      ['Gold Dust',["#d3807c",false]],
      ['Top Coat',["#f1f1f3",false]],
      ['Fireside',["#95051a",false]],
      ['Warrior',["#65001e",false]],
      ['Fearless',["#6f002a",false]],
      ['Poison',["#580048",false]],
      ['Skyfall',["#5ebbb6",false]],
      ['Verdure',["#60b18d",false]],
      ['Hemp',["#3c8d6f",false]],
      ['Grassroots',["#006159",false]],
      ['Saddle',["#ad6257",false]],
      ['Blazing',["#e91c2f",false]],
      ['Snowball',["#fffef6",false]],
      ['Carbon',["#221c1d",false]],
      ['Diva',["#aba6a8",false]],
      ['Cheers',["#ad7358",false]],
      ['Trinket',["#b07f7c",false]],
      ['Tomato Tango',["#d71828",false]],
      ['Jade Floret',["#75877F",false]],
      ['Scarlet Red',["#a12935",false]],
      ['Beachy Nude',["#6c1615",false]],
      ['Mocha',["#842a2b",false]],
      ['Spicd Capucino',["#d5797d",false]],
      ['Salmon Pink',["#a93e34",false]],
      ['Rustic Red',["#760d07",false]],
      ['Nude Punch',["#c07072",false]],
      ['Pink Valentine',["#7c2a2c",false]],
      ['Mystic Nude',["#972234",false]],
      ['Hot Pink',["#810e2f",false]],
      ['Fiery Scarlet',["#CF1600",false]],
      ['Driven Red',["#BC0103",false]],
      ['Vivid Crimson',["#B30D23",false]],
      ['Deep Maroon',["#7C071A",false]],
      ['Everyday Pink',["#C2657C",false]],
      ['Power Pink',["#B61048",false]],
      ['Dusty Rose',["#9A2037",false]],
      ['Confident Coral',["#E4231B",false]],
      ['Hustling Nude',["#c86d79",false]],
      ['Default Title',["#954038",false]],
      ['Strong Espresso',["#6A3E38",false]],
      ['Edgy Mauve',["#87394F",false]],
      ['Passion Berry',["#9D0D65",false]],
      ['Default Title',["#8F042C",false]],
      ['Default Title',["#4F023A",false]],
      ['Brick Nude',["#801f18",false]],
      ['Blue Ocean',["#014480",false]],
      ['Brown Latte',["#98483c",false]],
      ['Emerald Power',["#0a5158",false]],
      ['Green Pistachio',["#85a98d",false]],
      ['Grey Cloud',["#a98997",false]],
      ['Mauve Macaroon',["#e75d5a",false]],
      ['Nude Warmth',["#cf5364",false]],
      ['Pink Flash',["#f05071",false]],
      ['Purple Magic',["#52266e",false]],
      ['Red Carnival',["#d9013a",false]],
      ['Turquoise Wave',["#01a7a0",false]],
      ['Yellow Submarine',["#ffd72b",false]],
      ['Green',["#24432c",false]],
      ['Blue',["#072a35",false]],
      ['Brown',["#986a62",false]],
      ['Ivory',["#f8ab9c",false]],
      ['Sand',["#dc8a5f",false]],
      ['Beige',["#d79164",false]],
      ['Cinnamon',["#ce7a4b",false]],
      ['Walnut',["#a76046",false]],
      ['Ivory',["#ce936a",false]],
      ['Beige',["#c8936c",false]],
      ['Almond',["#ae7c63",false]],
      ['Sunkissed Glow',["#b77963",false]],
      ['Golden Hour',["#cb8c78",false]],
      ['C100 Cool Ivory',["#dea788",false]],
      ['W120 Warm CrÃ¨me',["#e7b88e",false]],
      ['C140 Cool Rose',["#dca587",false]],
      ['W160 Warm Sand',["#e6a87f",false]],
      ['W180 Warm Natural',["#e0ab7f",false]],
      ['N200 Neutral Nude',["#d7a67e",false]],
      ['N220 Neutral Medium',["#daa67f",false]],
      ['W240 Warm Beige',["#d9a47c",false]],
      ['N260 Neutral Honey',["#d4a27f",false]],
      ['C280 Cool Tan',["#cb956f",false]],
      ['C300 Cool Cinnamon',["#d39a6f",false]],
      ['W320 Warm Caramel',["#c49466",false]],
      ['N340 Neutral Almond',["#c0906c",false]],
      ['N360 Neutral Chestnut',["#bf8659",false]],
      ['C390 Cool Cocoa',["#a37158",false]],
      ['C380 Cool Walnut',["#cb956f",false]],
      ['W110 Warm Light',["#ebb585",false]],
      ['N150 Neutral Light',["#bd8c6d",false]],
      ['W230 Warm Wood',["#d2946b",false]],
      ['C330 Cool Mocha',["#b87e4d",false]],
      ['Desert Sunset',["#c96e60,#46405b,#c17b58,#c17b58,#dc8177,#eabaac",false]],
      ['Purple Haze',["#ee659b",false]],
      ['Ivory',["#F8D0B0",false]],
      ['Sand',["#D9B8A9",false]],
      ['Nude',["#D4BDB7",false]],
      ['Beige',["#C39A89",false]],
      ['Cinnamon',["#C5A091",false]],
      ['Almond',["#D8A37C",false]],
      ['Walnut',["#8D5832",false]],
      ['Cocoa',["#975635",false]],
      ['Warm Creme',["#DAA184",false]],
      ['Warm Natural',["#C08B69",false]],
      ['Neutral Nude',["#BA8968",false]],
      ['Cool Rose',["#DCAA87",false]],
      ['Neutral Medium',["#D9A580",false]],
      ['Warm Beige',["#D8A47D",false]],
      ['Warm Sand',["#A06D42",false]],
      ['Neutral Honey',["#E6B081",false]],
      ['Cool Walnut',["#E0A57B",false]],
      ['Neutral Almond',["#CA9166",false]],
      ['Cool Ivory',["#F1AE8B",false]],
      ['Cool Cinnamon',["#FFD4B2",false]],
      ['Darling Blue',["#066ead",false]],
      ['Bold Emerald',["#3d5959",false]],
      ['Alluring Silver',["#85878b",false]],
      ['Tough Metal',["#151316",false]],
      ['Ethereal White',["#eae6de",false]],
      ['Mysterious Black',["#111113",false]],
      ['Vibrant Azure',["#108faa",false]],
      ['Invincible Purple',["#6c456a",false]],
      ['Spirited Orange',["#bd2512",false]],
      ['Fearless Brown',["#794046",false]],
      ['Ivory',["#EAB091",false]],
      ['Sand',["#E39C69",false]],
      ['Nude',["#D3A27C",false]],
      ['Beige',["#C7936E",false]],
      ['Cinnamon',["#CA8C63",false]],
      ['Almond',["#AB7459",false]],
      ['Walnut',["#9A705A",false]],
      ['Cocoa',["#885A45",false]],
      ['Avocado',["#a1b271",false]],
      ['Pomelo',["#dfa6a5",false]],
      ['Mulberry',["#eabecf",false]],
      ['Matcha',["#88b477",false]],
      ['Black',["#000000",false]],
      ['Rose gold',["#b5837f",false]],
      ['Ivory',["#e3d5bc",false]],
      ['Firestarter Red',["#ae1f25",false]],
      ['Rhythmic Red',["#cf2937",false]],
      ['Revenge Red',["#b3001a",false]],
      ['Sour Cherry',["#a21346",false]],
      ['Starlet Pink',["#9e3165",false]],
      ['Royal Rouge',["#c7124f",false]],
      ['Blushing Brink',["#e20065",false]],
      ['Mild Mauve',["#976d6b",false]],
      ['Rose love',["#9a3e4d",false]],
      ['Pink Silk',["#963545",false]],
      ['Nude Sensation',["#993e4b",false]],
      ['Mulberry Feast',["#9c316b",false]],
      ['Wine N Dine',["#5e2936",false]],
      ['Mocha Shot',["#7a1a1b",false]],
      ['Brown Tan',["#8f3e3a",false]],
      ['Cherry Pop',["#942e45",false]],
      ['Runway Red',["#a82936",false]],
      ['Roasted Almond',["#995050",false]],
      ['Peach Fizz',["#b9444c",false]],
      ['Foxy Brown',["#6b3035",false]],
      ['Raspberry Shock',["#aa3d60",false]],
      ['Red Boots',["#a53333",false]],
      ['Indie Maroon',["#a01522",false]],
      ['Pink Footprint',["#be3850",false]],
      ['Nomad Pink',["#b84176",false]],
      ['Nude Umbrella',["#ae565d",false]],
      ['Brown Souvenir',["#732325",false]],
      ['Magenta Rhythm',["#7a1c43",false]],
      ['Wine Voyage',["#6b1f32",false]],
      ['Ruby',["#8e2822",false]],
      ['Crimson',["#b52c2b",false]],
      ['Salmon',["#81353c",false]],
      ['Rouge',["#a7634f",false]],
      ['Sepia',["#8a4f3c",false]],
      ['Carnation',["#a7315b",false]],
      ['Black',["#000000",false]],
      ['Smokin Glam',["#C99B9D",false]],
      ['Berry Martini',["#B7818F",false]],
      ['Stilettos',["#236690",false]],
      ['Sundowner',["#60464F",false]],
      ['Black',["#020202",false]],
      ['#fbdbcb',["#fbdbcb",false]],
      ['Red Ruby',["#ab4e3d",false]],
      ['Red Rose',["#ce5145",false]],
      ['Red Wine',["#a43d4c",false]],
      ['Red Orchid',["#b75c4f",false]],
      ['Red Blaze',["#c74445",false]],
      ['Pink Summer',["#d94b42",false]],
      ['Pink Prom',["#ea557c",false]],
      ['Pink Blush',["#c86e69",false]],
      ['Pink Date',["#b85455",false]],
      ['Pink Rose',["#bb6d71",false]],
      ['Red Retro',["#9e4e50",false]],
      ['Pink Candy',["#ac554c",false]],
      ['Pink Ruby',["#e13761",false]],
      ['Orange Rush',["#e14b40",false]],
      ['Orange Blossom',["#dd6e5a",false]],
      ['Mauve Secret',["#ae646d",false]],
      ['Plum Obsession',["#a03d50",false]],
      ['Burgundy Bloom',["#7c2938",false]],
      ['Nude Toast',["#a25c5f",false]],
      ['Brown Sugar',["#9a5952",false]],
      ['Graphite',["#4f4c41",false]],
      ['Espresso',["#675d55",false]],
      ['Raspberry',["#ff2541",false]],
      ['Berry Mint',["#e82e62",false]],
      ['Bubblegum',["#ff65a8",false]],
      ['Fresh Orange',["#ff8a6f",false]],
      ['Plum Feather',["#cf4157",false]],
      ['Blush Velvet',["#af5650",false]],
      ['Burgundy Lush',["#8a3f3a",false]],
      ['Coca Soft',["#963f38",false]],
      ['Coffee Lite',["#a05349",false]],
      ['Crimson Silk',["#cf3f48",false]],
      ['Rose Touch',["#ab5059",false]],
      ['Tangerine Fluff',["#E83832",false]],
      ['Brick Bloom',["#8f3f35",false]],
      ['Nude Cushion',["#b05f60",false]],
      ['Rosy Plum',["#7e1633",false]],
      ['Crimson Town',["#ac2831",false]],
      ['Ruby Space',["#ac322f",false]],
      ['Scarlet lane',["#ad302f",false]],
      ['Rouge Metro',["#aa291f",false]],
      ['Coral Place',["#c23938",false]],
      ['Blush Site',["#d75788",false]],
      ['Rose Ville',["#ac2c45",false]],
      ['Candy Centre',["#c52126",false]],
      ['Bare Castle',["#974f35",false]],
      ['Berry land',["#863c45",false]],
      ['Plum Local',["#863965",false]],
      ['Nude Scape',["#904656",false]],
      ['Red Extreme',["#a70034",false]],
      ['Sinful Cherry',["#ba1b4b",false]],
      ['Berry Boost',["#a70053",false]],
      ['Delicious Plum',["#7f034b",false]],
      ['Brunch Nude',["#bb887c",false]],
      ['Royal Rush',["#a94750",false]],
      [' MPS08',["#ac7d5b",false]],
      [' MPS07',["#ac7d5b",false]],
      [' MPS06',["#ac7d5b",false]],
      [' MPS05',["#ac7d5b",false]],
      [' MPS04',["#ac7d5b",false]],
      [' MPS03',["#ac7d5b",false]],
      [' MPS02',["#ac7d5b",false]],
      [' MPS01',["#ac7d5b",false]],
      ['MPS01',["#ac7d5b",false]],
      ['MPS02',["#ac7d5b",false]],
      ['MPS03',["#ac7d5b",false]],
      ['MPS04',["#ac7d5b",false]],
      ['MPS05',["#ac7d5b",false]],
      ['MPS06',["#ac7d5b",false]],
      ['MPS07',["#ac7d5b",false]],
      ['MPS08',["#ac7d5b",false]],
      ['MPS09',["#ac7d5b",false]],
      ['MPS10',["#ac7d5b",false]],
      ['MPS11',["#ac7d5b",false]],
      ['MPS12',["#ac7d5b",false]],
      ['MPS13',["#ac7d5b",false]],
      ['MPS14',["#ac7d5b",false]],
      ['MPS15',["#ac7d5b",false]],
      ['MPS16',["#ac7d5b",false]],
      ['MPS17',["#ac7d5b",false]],
      ['MPS18',["#ac7d5b",false]],
      ['MPS19',["#ac7d5b",false]],
      ['MPS20',["#ac7d5b",false]],
      ['MPS21',["#ac7d5b",false]],
      ['MPS22',["#ac7d5b",false]],
      ['MPS23',["#ac7d5b",false]],
      ['MPS24',["#ac7d5b",false]],
      ['Charcoal',["#333131",false]],
      ['Coffee',["#756060",false]],
      ['Raving Red',["#c92439",false]],
      ['Victorian Rose',["#ee2b4e",false]],
      ['Cherry Bite',["#ed1846",false]],
      ['Sugar-n-Spice',["#ef3f3e",false]],
      ['M1',["#c80047",false]],
      ['M2',["#a56958",false]],
      ['M3',["#c18c93",false]],
      ['M5',["#a00041",false]],
      ['M9',["#c20055",false]],
      ['M10',["#276456",false]],
      ['M11',["#bbbdb9",false]],
      ['M16',["#9bcfc4",false]],
      ['M18',["#567b3f",false]],
      ['M19',["#fec600",false]],
      ['T2',["#78abce",false]],
      ['T3',["#c1877f",false]],
      ['P1',["#e8d4c4",false]],
      ['P2',["#c3c2c5",false]],
      ['S1',["#9c3c58",false]],
      ['S5',["#b4386b",false]],
      ['G1',["#90815b",false]],
      ['G4',["#7d2736",false]],
      ['G5',["#aeb7b9",false]],
      ['G9',["#cb2952",false]],
      ['G11',["#aea465",false]],
      ['G12',["#000000",false]],
      ['U2',["#d8879e",false]],
      ['U4',["#8e90ad",false]],
      ['C2',["#9d85bb",false]],
      ['C3',["#5e758f",false]],
      ['C4',["#bca07a",false]],
      ['C5',["#609698",false]],
      ['C6',["#6d6b78",false]],
      ['C1',["#af93bc",false]],
      ['Tomato Tango',["#d71828",false]],
      ['Scarlet Red',["#a12935",false]],
      ['Soft Rose',["#ef8f82",false]],
      ['Tawny Brown',["#b9634d",false]],
      ['Pink Diamond',["#e685a8",false]],
      ['Jade Floret',["#75877F",false]],
      ['Gold Dust',["#d3807c",false]],
      ['Top Coat',["#f1f1f3",false]],
      ['Fireside',["#95051a",false]],
      ['Warrior',["#65001e",false]],
      ['Fearless',["#6f002a",false]],
      ['Poison',["#580048",false]],
      ['Saddle',["#ad6257",false]],
      ['Snowball',["#fffef6",false]],
      ['Carbon',["#221c1d",false]],
      ['Diva',["#aba6a8",false]],
      ['Cheers',["#ad7358",false]],
      ['Trinket',["#b07f7c",false]],
      ['Enigma',["#2d0606",false]],
      ['Pink Date',["#df5289",false]],
      ['Vineyard',["#3a0119",false]],
      ['Royalty',["#53012c",false]],
      ['Bubble',["#F5B493",false]],
      ['Ballerina',["#F389A1",false]],
      ['Macaroon',["#EB4966",false]],
      ['Morpho',["#5683BF",false]],
      ['Snowcone',["#80CEDA",false]],
      ['Bluebells',["#32436E",false]],
      ['Raisin',["#5E60AD",false]],
      ['Verbena',["#BE62A3",false]],
      ['Pumpkin',["#F05E22",false]],
      [' Black',["#0d1611",false]],
      ['Black',["#060604",false]],
      ['Blue',["#2f3870",false]],
      ['Golden',["#e6b848",false]],
      ['Green',["#31473b",false]],
      ['Black',["#000000",false]],
      ['Color 57',["#8b2b36",false]],
      ['Color 55',["#ab3d60",false]],
      ['Color 70',["#87122c",false]],
      ['Color 59',["#df7016",false]],
      ['Color 60',["#687676",false]],
      ['Color 71',["#7c2a30",false]],
      ['Color 63',["#01bcab",false]],
      ['Color 72',["#01c5df",false]],
      ['Color 65',["#381f59",false]],
      ['Color 73',["#1a3a8d",false]],
      ['Gold 04',["#a899ba",false]],
      ['Shade 08',["#fef5f0",false]],
      ['Shade 10',["#bcbdbf",false]],
      ['Lavender 11',["#a74375",false]],
      ['Shade 14',["#b37c9b",false]],
      ['Pinks 18',["#c43c84",false]],
      ['Pinks 19',["#f15a6d",false]],
      ['Pinks 21',["#b00259",false]],
      ['Reds 22',["#b74f66",false]],
      ['Pinks 23',["#f2525c",false]],
      ['Reds 24',["#9c0238",false]],
      ['Reds 25',["#7c204f",false]],
      ['Blue 27',["#0193a2",false]],
      ['Reds 31',["#f52e41",false]],
      ['Reds 33',["#5e1c2a",false]],
      ['Lavender 36',["#d9689e",false]],
      ['Shade 41',["#bc635b",false]],
      ['Shade 42',["#a52b66",false]],
      ['Shade 43',["#c0284f,",false]],
      ['Shade 61',["#ed5321",false]],
      ['Shade 62',["#be1d2c",false]],
      ['Shade 66',["#bc296d",false]],
      ['Grape Hint',["#c63c89",false]],
      ['Crimson Lush',["#e25051",false]],
      ['Ruby Satin',["#7d484d",false]],
      ['Berry Luxe',["#db413c",false]],
      ['Shade 01',["#e09e63",false]],
      ['Shade 02',["#be956a",false]],
      ['Shade 04',["#c9a075",false]],
      ['Shade 05',["#eab179",false]],
      ['Golden Medium 03',["#e6bb8c",false]],
      ['Ivory Fair 01',["#c0947a",false]],
      ['Beige Honey 05',["#caa07e",false]],
      ['Soft Pink',["#f2cdb3",false]],
      ['Warm Pink',["#feaaa2",false]],
      ['Marble',["#e3b192",false]],
      ['Pearl',["#ea9c76",false]],
      ['Shell',["#e79e70",false]],
      ['Coral',["#e79e70",false]],
      ['Maroon',["#713334",false]],
      ['Red',["#c7161d",false]],
      ['Sun Kissed',["#ca8e79",false]],
      ['Desert Rose',["#bf6f71",false]],
      ['Mystic Nudes',["#936d5c,#936d5c,#946957,#84565a",false]],
      ['Rose Ivory',["#e79666",false]],
      ['Beige Vanilla',["#fbb158",false]],
      ['Sand',["#c4a38e",false]],
      ['Natural',["#cdad96",false]],
      ['Honey',["#b6927f",false]],
      ['Caramel',["#c6a088",false]],
      ['Black',["#000000",false]],
      ['Silver Slate',["#6b6068",false]],
      ['Ash Brown',["#4f372d",false]],
      ['Bronze Rust',["#61564a",false]],
      ['Prussian Blue',["#38434a",false]],
      ['Cool Ivory',["#f9c19c",false]],
      ['Warm CrÃ¨me',["#e7bc8c",false]],
      ['Warm Sand',["#e5ac79",false]],
      ['Warm Natural',["#e0a977",false]],
      ['Warm Beige',["#dca678",false]],
      ['Neutral Honey',["#dca67b",false]],
      ['Cool Tan',["#d7a16f",false]],
      ['Cool Cinnamon',["#d8a076",false]],
      ['Cool Walnut',["#c28d64",false]],
      ['Neutral Medium',["#e1ac7b",false]],
      ['Red Carnival',["#c3002b",false]],
      ['Maroon Magic',["#8b0526",false]],
      ['Plum Spell',["#ac0035",false]],
      ['Pink Passion',["#e80054",false]],
      ['Wine Whisper',["#701c30",false]],
      ['British Brown',["#a75949",false]],
      ['Default Title',["#d31646",false]],
      ['Elegant Pink',["#c1636a",false]],
      ['01 Mandarino',["#ee7e4f",false]],
      ['03 Raspberry',["#e85d90",false]],
      ['04 Candy Floss',["#f0768f",false]],
      ['06 Spearmint',["#7fd0d6",false]],
      ['07 Matcha',["#8ac977",false]],
      ['08 Limoncello',["#f7f170",false]],
      ['Black',["#000000",false]],
      ['Black',["#000000",false]],
      ['Soft Nude',["#975d50",false]],
      ['Wild Brown',["#884e49",false]],
      ['Brazen Caramel',["#9f6851",false]],
      ['Vintage Rust',["#a35e55",false]],
      ['Cherry',["#E00022",false]],
      ['Purelipcare',["#EAA3C1",false]],
      ['Strawberry',["#E91966",false]],
      ['Mango',["#E1101C",false]],
      ['Apricot',["#DB2F1C",false]],
      ['Caramel',["#B94335",false]],
      ['Insta Pink',["#EA88B1",false]],
      ['Black',["#0d0d0d",false]],
      ['Fair',["#f0cea7",false]],
      ['Medium',["#fdca9e",false]],
      ['Honey',["#e1ad86",false]],
      ['Natural Black',["#000000",false]],
      ['Dark Brown',["#ae5f43",false]],
      ['Beige Honey',["#ecb183",false]],
      ['Golden Light',["#f6cd95",false]],
      ['Golden Medium',["#e9b58c",false]],
      ['Ivory Fair',["#f0cea7",false]],
      ['Rose Fair',["#f3af88",false]],
      ['Almond Honey',["#f3af88",false]],
      ['Black',["#000000",false]],
      ['Beige Caramel',["#f2aa70",false]],
      ['Rose Honey',["#e89666",false]],
      ['Rose Ivory',["#edbcae",false]],
      ['Beige Vanilla',["#fbb158",false]],
      ['Walnut',["#b27b59",false]],
      ['Warm Mocha',["#905c41",false]],
      [' Desert Rose',["#986f6b",false]],
      ['Vintage Pink',["#915157",false]],
      ['Mulberry Feast',["#9c316b",false]],
      ['Mild Mauve',["#976d6b",false]],
      ['Crazy Tangerine',["#e44026",false]],
      ['Firestarter Red',["#ae1f25",false]],
      ['Nude Hit',["#93372c",false]],
      ['Red Vibe',["#721d19",false]],
      ['Mauve Mix',["#7b324d",false]],
      ['Peach Rose',["#d16653",false]],
      ['Bronze',["#e5a373",false]],
      ['Honey',["#fbc88b",false]],
      [' Black',["#000000",false]],
      ['W120 Warm CrÃ¨me',["#e7af7a",false]],
      ['W160 Warm Sand',["#dbad8e",false]],
      ['N220 Neutral Medium',["#d79d6e",false]],
      ['W180 Warm Natural',["#e29454",false]],
      ['Cool Ivory',["#fbb67c",false]],
      ['Ivory Cream',["#e7af7a",false]],
      ['Rose Silk',["#dbad8e",false]],
      ['Silky Golden',["#da9f76",false]],
      ['Natural Light',["#d49774",false]],
      ['Honey Dew',["#d79d6e",false]],
      ['Natural Almond',["#d69567",false]],
      ['Red Letter',["#de2b31",false]],
      ['Red Coat',["#da0533",false]],
      ['Red Rust',["#8c2f23",false]],
      ['Berry Base',["#902e3b",false]],
      ['Coral Date',["#e36058",false]],
      ['Pink Perfect',["#e82c5f",false]],
      ['Ruby Rush',["#d82f4e",false]],
      ['Pink Party',["#8b4651",false]],
      ['Scarlet Spritzer',["#ee4a53",false]],
      ['Honey Haze',["#e15a28",false]],
      ['Pink Champagne',["#fc8d94",false]],
      ['Peach Punch',["#f9807a",false]],
      ['Cocoa Truffle',["#7c3426",false]],
      ['Plum Pink',["#bc2263",false]],
      ['Maroon Mix',["#913446",false]],
      ['Blushing Nude',["#cd7170",false]],
      ['Rosy Sunday',["#903d45",false]],
      ['Nude Touch',["#a85f55",false]],
      ['Mauve Matter',["#aa5b67",false]],
      ['Garnet Punch',["#714157",false]],
      ['Sangria Weekend',["#713d3d",false]],
      ['Deep Wine',["#790427",false]],
      ['Roseatte Red',["#a64244",false]],
      ['Chocolate Crush',["#835056",false]],
      ['Caramel Latte',["#ac573f",false]],
      ['Red Twist',["#d50e16",false]],
      ['Burgundy Passion',["#80001e",false]],
      ['Pink Rose',["#db1d3e",false]],
      ['Blush Pink',["#e95d6f",false]],
      ['Dusty Pink',["#a26769",false]],
      ['Peachy Affair',["#d84c54",false]],
      ['Rose Day',["#b01645",false]],
      ['Brown Walnut',["#75433c",false]],
      ['Rustic Brown',["#924930",false]],
      ['Coffee Command',["#96554f",false]],
      ['Scarlet Surge',["#db284e",false]],
      ['Cherry Chic',["#962d33",false]],
      ['Brick Blush',["#cc503c",false]],
      ['Iconic Red',["#c6153c",false]],
      ['Red Velvet',["#831033",false]],
      ['Default Title',["#d05a74#d58971#ba7e5a#c56c5a",false]],
      ['Default Title',["#000000",false]],
      ['Peach Affair',["#cb625f",false]],
      ['Coral Punch',["#f4948e",false]],
      ['Nude Flush',["#f59f98",false]],
      ['Pretty Pink',["#ed769a",false]],
      ['Almond',["#de9b6d",false]],
      ['Apricot',["#ff9d68",false]],
      ['Melon',["#fcc79b",false]],
      ['Marble',["#fcd1a7",false]],
      ['01 Classic Ivory',["#d9ba82",false]],
      ['03 Golden Sand',["#cd8b5e",false]],
      ['04 Golden Light',["#f6cd95",false]],
      ['05 Beige Honey',["#fbb788",false]],
      ['02 Rose Creme',["#fdae85",false]],
      ['06 Almond Honey',["#f2a171",false]],
      ['Black',["#000000",false]],
      ['Black',["#000000",false]],
      ['Rose Blush',["#e6746f",false]],
      ['Coral Blush',["#e97e7c",false]],
      ['Pink Blush',["#db6f86",false]],
      ['Candy Shine',["#ed1f80",false]],
      ['Plum Shine',["#973965",false]],
      ['Pink Shine',["#e04d5f",false]],
      ['Red Shine',["#bf2a52",false]],
      ['Cherry Shine',["#b61441",false]],
      ['Crimson Shine',["#be1041",false]],
      ['Cool Ivory',["#f6d0bd",false]],
      ['Warm Crème',["#eda773",false]],
      ['Cool Rose',["#e29c7a",false]],
      ['Warm Sand',["#dcbaa1",false]],
      ['Warm Natural',["#f8a464",false]],
      ['Neutral Nude',["#e0ae8d",false]],
      ['Neutral Medium',["#e4a570",false]],
      ['Warm Beige',["#dd9a6d",false]],
      ['Neutral Honey',["#e39b73",false]],
      ['Cool Cinnamon',["#d37d3",false]],
      ['Neutral Almond',["#da9c63",false]],
      ['Cool Walnut',["#af683c",false]],
      ['Ivory',["#fac09a",false]],
      ['Sand',["#c9946f",false]],
      ['Beige',["#e59b69",false]],
      ['Cinnamon',["#e28d65",false]],
      ['Ivory',["#fdd4b6",false]],
      ['Sand',["#f9c69b",false]],
      ['Nude',["#fac5a6",false]],
      ['Beige',["#d89f72",false]],
      ['Cinnamon',["#edad89",false]],
      ['Walnut',["#bf895d",false]],
      ['Toffee Touch',["#bf6d62",false]],
      ['Apricot Crush',["#c76552",false]],
      ['Dusty Rose',["#cc6570",false]],
      ['Candy Floss',["#c84c4a",false]],
      ['Lavender Mist',["#97346d",false]],
      ['Nude Nudge',["#a45551",false]],
      ['Bubblegum Blush',["#fd636b",false]],
      ['Crimson Kiss',["#c93e48",false]],
      ['Gold',["#eee1dc",false]],
      ['Bronze',["#c2714c",false]],
      ['Night Diva',["#e0aa90",false]],
      ['Day Queen',["#cf8177",false]],
      ['Orange',["#fa8e74",false]],
      ['Green',["#b4dcc1",false]],
      ['Purple',["#c1b0d2",false]],
      ['Smokey Diva',["#a7a7a7",false]],
      ['Nude Bomb',["#e3687e" ,false]],
      ['Golden Hour Goddess',["#be7356",false]],
      ['Pink Beauty',["#de97a0",false]],
      ['Block Tip',["#000000",false]],
      ['Fine Tip',["#000000",false]],
      ['Marbel',["#e3b192",false]],
      ['Party Chic',["#d73161",false]],
      ['Evening Glam',["#8c2f39",false]],
      ['Pink Vibe Only',["#ce4d52",false]],
      ['Nice Nudes',["#d95b62",false]],
      ['W120 Warm Crème',["#e7b88e",false]],
      ['Warm Creme Pink',["#c8936c",false]],
      ['Smokey Glam',["#b98a6e",false]],
      ['Royal Peacock',["#ab8059",false]],
     ['Mocha Maiden 301',["#98565a",false]],
     ['Carnation Craze 101',["#b61d32",false]],
     ['Regal Rose 102',["#9f2941",false]],
     ['Daring Dahlia 201',["#d9296a",false]],
     ['Nude Nectar 201',["#bc5e5e",false]],
     ['Pink Poppy 202',["#a7455a",false]],
     ['Pink Tulip 203',["#ae566c",false]],
     ['Cocoa Carnation 204',["#7d3e39",false]],
     ['Vintage rose',["#ff4867",false]],
     ['Pink Blossom',["#f97b84",false]],
     ['Frosted Pink',["#e17283",false]],
     ['Everyday Nude',["#ed907e",false]],
     ['Coral Charm',["#dd776b",false]],
     ['Pink Bloom',["#d8495d",false]],
     ['Peach Petal 205',["#c24d3c",false]],
     ['Blush Peony 206',["#b25d64",false]],
     ['Cherry Blossom 207',["#eb1c2e",false]],
     ['Scarlet Rose 209',["#bb4039",false]],
     ['Majestic Magnolia 202',["#bc3265",false]],
     ['Orchid Oomph 203',["#b93356",false]],
     ['Forget me not 308',["#a33e4c",false]],
     ['Insta Pink C1',["#c8206d",false]],
     ['Peachy Nude C2',["#fc6171",false]],
     ['Cherry Red C3',["#9f1b27",false]],
     ['Cocoa Brown C4',["#7c372e",false]],
     ['Pearl C5',["#efedec",false]],
     ['Hotpink C6',["#bc4d5c",false]],
     ['Ruby Glow',["Brown",false]],
     ['Sunset Kis',["#CF002C",false]],
     ['Vacation Nude',["#9A3F3A",false]],
     ['Boardroom Blush',["#874141",false]],
     ['Monday Mocha',["#6B3B36",false]],
     ['Coffee Break',["#7C442B",false]],
     ['Team Toffee',["#C37255",false]],
     ['Boss Brick',["#CB4955",false]],
     ['Blush Business',["#A64E5A",false]],
     ['Workday Rose',["#892638",false]],
     ['Espresso Martini',["#A25436",false]],
     ['Hot Pink Cosmo',["#FFA1AA",false]],
     ['Hot Pink Cosmo',["#FFA1AA",false]],
     ['Chocolate Temptation',["#A94746",false]],
     ['Nude Naturalle',["#A35153",false]],
     ['Naturelle',["#FED4BE",false]],
     ['Crème',["#FED5A0",false]],
     ['Latte',["#FFDCB1",false]],
     ['Dolce',["EEB894",false]],
     ['Desert Sunset',["CE7665",false]],
     ['NudeMuse-UN1', ["#99564e",false]],
     ['NudeToffe-UN2',["#ae5d48",false]],
     ['PetalNude-UN3', ["#933931",false]],
     ['NudeMocha-UN4', ["#b9402f",false]],
     ['MauveHue-UN5', ["#a4484d",false]],
     ['PurpSprk-UW1', ["#a1354f",false]],
     ['WineVelvt-UW2', ["#530b18",false]],
     ['PinkBliss-UP1', ["#cd2549",false]],
     ['PinkPop-UP2', ["#da1d46",false]],
     ['BoldRed-UR1', ["#b21b1e",false]],
     ['RedFlame-UR2', ["#670d16",false]]
  ]);

  function findHaxCode(key)  {
    if (colorMap.has(key)) {
      return colorMap.get(key);
    } else {
      return [key, false];
    }
  }
//////////////////////////////////////////////////////////////////////////////////////////////////////////////

$(".st-search-icon").on('click', function(e){
    if($("#stDesktopSearchBox").css("display") === 'none'){
      $("#stDesktopSearchBox").css("display", 'block');
      $(".wizzy-search-input").click();
      $(".wizzy-search-input").focus();
    }
    else{
      $("#stDesktopSearchBox").css("display", 'none') 
    }
  })

  const replaceTemplate = (div) => {
      let newDiv = document.getElementById(div + "-new").text;
      let oldDiv = document.getElementById(div);
      oldDiv.text = newDiv;
    };

  window.onWizzyScriptLoaded = function () {
    window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,
    function (payload) {
    // console.log(payload,"BEFORE_LAZY_INIT");
    payload.search.configs.facets.configs = payload.search.configs.facets.configs.map(item => {
      if(item.key === "discountPercentage") {
        item["config"] = {};
        item["config"]["interval"] = 10;
      }
      return item;
  });

      // console.log(payload.search.configs.facets.configs, "<===payload.search.configs.facets.configs");
      if(window.wizzyConfig.common.isOnCategoryPage) {
        payload.common.lazyDOMConfig.contentDOMIdentifiers = ["#wizzy-shopify-collection-page-wrapper"];
      } else {
        payload.common.lazyDOMConfig.contentDOMIdentifiers = ["#main"];
      }
      return payload;
    }
  );
  window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_INIT,function (payload) {
    //window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = ["#main"];
    window.wizzyConfig["search"]["configs"]["pagination"]["infiniteScrollOffset"] = {
          desktop:$("footer").height()  + 2000,
           mobile:$("footer").height() + 2000,
      };
    // payload.filters.configs.displayAsDrawer = true;
    // payload.filters = {configs:{keepOpenedInMobileAfterApply:true}}
    
    payload.filters = {configs:{keepOpenedInMobileAfterApply:true, displayAsDrawer:true, keepOpenedInDesktopAfterApply:true}}
    window.wizzyConfig.filters.configs.displayAsDrawer=false;

    if(window?.wizzyConfig?.common?.isOnCategoryPage){
    window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers =  ["#wizzy-shopify-collection-page-container"]
    }
    else{
      window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers =  ["#main"]
    }
    payload.autocomplete.configs.defaultBehaviour = {
        "suggestions": {
        "enabled": true,
        "displayRecent": false,
        "displayTrending": false,
        "defaultPool": [
    {
        "value": "Combos",
        "valueHighlighted": "Combos",
        "filters": [],
        "payload": [],
        "section": "others"
    },
    {
        "value": "New Launches",
        "valueHighlighted": "New Launches",
        "filters": [],
        "payload": [],
        "section": "others"
    },
    {
        "value": "Best Deals",
        "valueHighlighted": "Best Deals",
        "filters": [],
        "payload": [],
        "section": "others"
    },
    {
        "value": "Foundation",
        "valueHighlighted": "Foundation",
        "filters": [],
        "payload": [],
        "section": "others"
    },
    {
        "value": "Lipstick",
        "valueHighlighted": "Lipstick",
        "filters": [],
        "payload": [],
        "section": "others"
    },
    {
        "value": "Eye Liner",
        "valueHighlighted": "Eye Liner",
        "filters": [],
        "payload": [],
        "section": "others"
    }
]
        },
        "topProducts": {
            "enabled": true,
            "displayRecent": "false",
            "displayTrending": "false",
            "defaultPool": {
                "method": "filters",
                "expiry": "session",
                "data": {
                    "categories": [
                        "new-launches"
                    ],
                    "sort": [
                      {
                        "field": "relevance",
                        "order": "asc"
                      },
                      // {
                      //   "field": "product_shahana-x-wardrobe_sortOrder:float",
                      //   "order": "asc"
                      // }
                    ],
                    "productsCount": 6
                }
            }
        }
    };

    payload.search.configs.noProductsFound = {
        "showProducts": true,
        "defaultPool": {
            "method": "filters",
            "expiry": "session",
            "data": {
                "productsCount": 50,
                "categories": [
                    "bestsellers"
                ],
                "sort": [
                    {
                      "field": "relevance",
                      "order": "asc"
                    },
                    // {
                    //   "field": "product_shahana-x-wardrobe_sortOrder:float",
                    //   "order": "asc"
                    // }
                ],
                "type": "NO_RESULTS_FOUND",
            }
        }
    };
    return payload;  
  });  
    window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_SUGGESTIONS_RENDER,function (payload) {
      payload.suggestions.forEach((suggestion)=>{
        if(!suggestion.isHead){
          suggestion.label = suggestion.label.replace("_"," ").toLowerCase()
          suggestion.searchTerm = suggestion.label.replace("_"," ").toLowerCase()
          
        }
      })
    return payload;
    
  })


   window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,function (payload) {
      $(".PageHeader").css("display","none")
     $(".default-title-header").css("display","none")

      const closeIcon = document.querySelector('.searchs-form_close_icon');
      if (closeIcon) {
          closeIcon.click();
      } 
     
    return payload;
    
  })

   window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,function (payload) {
     // console.log(payload.filters,"BEFORE_FILTERS_EXECUTED");
     if(payload.filters){
       payload.filters.inStock = ["true","false"]
     }

     if(payload.filters){
       if(payload.filters.page==2){
        // const elements = document.querySelectorAll('.wizzy-custom-banner');
        // if (elements.length > 1) {
        //     const secondElement = elements[1];
        //     secondElement.classList.add('visible');
        // }
        setTimeout(() => {
            const elements = document.querySelectorAll('.wizzy-custom-banner');
            if (elements.length > 1) {
                const secondElement = elements[1];
                secondElement.classList.add('visible');
            }
        }, 1000);

       }
     }

   function addLteToDiscounts(discounts) {
        for (let i = 0; i < discounts.length; i++) {
            let current = discounts[i];
            let gteValue = parseInt(current["gte"], 10); // Convert string to number
            
            let lteValue = gteValue + 10; // Adding 10 to the gte value
    
            current["lte"] = lteValue.toString(); // Convert number back to string
        }
    }

     if(payload.filters){
       if(payload.filters.discountPercentage){
         addLteToDiscounts(payload.filters.discountPercentage);
       }
       // console.log(payload.filters.discountPercentage," wizzy discount")
     }


  //     if (payload.filters) {
  //     if (payload.filters.sort) {
  //       console.log(payload.filters.sort)
        
  //         function changeSortOrder() {
  //            var sort = payload.filters.sort;
  //            console.log("it's working",sort)

  //             if (sort.length === 2 && sort[0].field === "relevance" && sort[1].field === "name") {
  //               console.log("it's working 2")
  //                 payload.filters.sort = [{
  //                         "field": "name",
  //                         "order": "asc"
  //                     },
  //                     {
  //                         "field": "relevance",
  //                         "order": "asc"
  //                     }
  //                 ];
  //             }
  //         }
  //         changeSortOrder();
  //     }
  // }     

     // console.log(payload.filters.sort,"BEFORE_FILTERS_EXECUTED");
     
    return payload;
    
  })

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (data) {
      // console.log(data," <= VIEW_RENDERED");

      if(wizzyConfig.common.isOnCategoryPage){
        if(data.data.api === "filter"){
          let totalProducts = data.data.response.payload.total;
          let elementP = document.querySelector('.wizzy-total-products');
          if(elementP){
            elementP.textContent = `${totalProducts} items`;
          }
        }
      }

     // $(document).ready(function() {
     //  $('button[data-action="add-to-cart"]').on('click', function(e) {
     //      e.preventDefault();

     //      var form = $(this).closest('form');

     //      fetch('https://www.lakmeindia.com/cart.js')
     //          .then(response => {
     //              if (!response.ok) {
     //                  throw new Error('Network response was not ok ' + response.statusText);
     //              }
     //              return response.json();
     //          })
     //          .then(cartData => {
     //              const totalCartCount = cartData.item_count;
  
     //              if (totalCartCount >= 15) {
     //                  var copyPopup = document.querySelector('.cart__popup_mainn');
     //                  var reachedLimit = document.querySelector('.cart__popup_mainn .cart__popup_countt');
     //                  if (reachedLimit) {
     //                      reachedLimit.textContent = "You can only add a maximum of 15 units in the bag.";
     //                  }
     //                  if (copyPopup) {
     //                      setTimeout(function() {
     //                          copyPopup.classList.add('copy-code-animation');
     //                          setTimeout(function() {
     //                              copyPopup.classList.remove('copy-code-animation');
     //                          }, 3000);
     //                      }, 1000);
     //                  }
     //                  return; 
     //              }
  
     //              var cartItems = parseInt($(this).attr('cartitems'), 10) || 0;
     //              cartItems += 1;
     //              // console.log(cartItems, "Wizzy Cart Item");

     //              if (cartItems < 6) {
     //                  var popup = document.querySelector('.cart__popup_main');
     //                  if (popup) {
     //                      setTimeout(function() {
     //                          popup.classList.add('atc-animation');
     //                          setTimeout(function() {
     //                              popup.classList.remove('atc-animation');
     //                          }, 3000);
     //                      }, 1000);
     //                  }
     //              } else {
     //                var copyPopup = document.querySelector('.cart__popup_mainn');
     //    					var reachedLimit = document.querySelector('.cart__popup_mainn .cart__popup_countt');
     //    					if (reachedLimit) {
     //    						reachedLimit.textContent = "You have reached the max quantity limit to add this product.";
     //    					}
     //    					if (copyPopup) {
     //    						setTimeout(function() {
     //    							copyPopup.classList.add('copy-code-animation');
        
     //    							setTimeout(function() {
     //    								copyPopup.classList.remove('copy-code-animation');
     //    							}, 3000);
     //    						}, 1000);
     //    					}
     //                }
     //                form.submit();
     //            })
     //              .catch(error => {
     //                  console.error('Error fetching cart data:', error);
     //              });
     //      });
     //  });


      $(document).ready(function() {
          $('button[data-action="add-to-cart"]').off('click').on('click', function(e) {
              e.preventDefault();
              var form = $(this).closest('form');
              fetch('https://www.lakmeindia.com/cart.js')
                  .then(response => {
                      if (!response.ok) {
                          throw new Error('Network response was not ok ' + response.statusText);
                      }
                      return response.json();
                  })
                  .then(cartData => {
                      const totalCartCount = cartData.item_count;
                      if (totalCartCount >= 15) {
                          var copyPopup = document.querySelector('.cart__popup_mainn');
                          var reachedLimit = document.querySelector('.cart__popup_mainn .cart__popup_countt');
                          if (reachedLimit) {
                            reachedLimit.textContent = "You can only add a maximum of 15 units in the bag.";
                          }
                          if (copyPopup) {
                              setTimeout(function() {
                                  copyPopup.classList.add('copy-code-animation');
                                  setTimeout(function() {
                                      copyPopup.classList.remove('copy-code-animation');
                                  }, 3000);
                              }, 1000);
                          }
                          return; 
                      }
                      var cartItems = parseInt($(this).attr('cartitems'), 10) || 0;
                      cartItems += 1;
                      // console.log(cartItems, "Wizzy Cart Item");
                      if (cartItems < 6) {
                          var popup = document.querySelector('.cart__popup_main');
                          if (popup) {
                              setTimeout(function() {
                                  popup.classList.add('atc-animation');
                                  setTimeout(function() {
                                      popup.classList.remove('atc-animation');
                                  }, 3000);
                              }, 1000);
                          }
                      } else {
                          var copyPopup = document.querySelector('.cart__popup_mainn');
                          var reachedLimit = document.querySelector('.cart__popup_mainn .cart__popup_countt');
                          if (reachedLimit) {
                              reachedLimit.textContent = "You have reached the max quantity limit to add this product.";
                          }
                          if (copyPopup) {
                              setTimeout(function() {
                                  copyPopup.classList.add('copy-code-animation');
      
                                  setTimeout(function() {
                                      copyPopup.classList.remove('copy-code-animation');
                                  }, 3000);
                              }, 1000);
                          }
                      }
                      form.submit();
                  })
                  .catch(error => {
                      console.error('Error fetching cart data:', error);
                  });
          });
      });

      
      return data;
    }
  );

    window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
    function (data) {
      // console.log(data," <= PRODUCTS_CACHED_RESULTS_RENDERED");
      // document.querySelectorAll('.cstm_product_grid_atc_button').forEach(function(button) {
      //     button.addEventListener('click', function() {
      //         var popup = document.querySelector('.cart__popup_main');
      //         if (popup) {
      //             setTimeout(function() {
      //                 popup.classList.add('atc-animation');
                      
      //                 setTimeout(function() {
      //                     popup.classList.remove('atc-animation');
      //                 }, 3000);
      //             }, 1000);
      //         }
      //     });
      // });

      getCart();

      ////////////////////
      $(document).ready(function() {
        $('button[data-action="add-to-cart"]').off('click').on('click', function(e) {
              e.preventDefault();
      
              var form = $(this).closest('form');
      
              fetch('https://www.lakmeindia.com/cart.js')
                  .then(response => {
                      if (!response.ok) {
                          throw new Error('Network response was not ok ' + response.statusText);
                      }
                      return response.json();
                  })
                  .then(cartData => {
                      const totalCartCount = cartData.item_count;
      
                      if (totalCartCount >= 15) {
                          var copyPopup = document.querySelector('.cart__popup_mainn');
                          var reachedLimit = document.querySelector('.cart__popup_mainn .cart__popup_countt');
                          if (reachedLimit) {
                              reachedLimit.textContent = "You can only add a maximum of 15 units in the bag.";
                          }
                          if (copyPopup) {
                              setTimeout(function() {
                                  copyPopup.classList.add('copy-code-animation');
                                  setTimeout(function() {
                                      copyPopup.classList.remove('copy-code-animation');
                                  }, 3000);
                              }, 1000);
                          }
                          return; 
                      }
      
                      var cartItems = parseInt($(this).attr('cartitems'), 10) || 0;
                      cartItems += 1;
                      // console.log(cartItems, "Wizzy Cart Item");
      
                      if (cartItems < 6) {
                          var popup = document.querySelector('.cart__popup_main');
                          if (popup) {
                              setTimeout(function() {
                                  popup.classList.add('atc-animation');
                                  setTimeout(function() {
                                      popup.classList.remove('atc-animation');
                                  }, 3000);
                              }, 1000);
                          }
                      } else {
                          var copyPopup = document.querySelector('.cart__popup_mainn');
                          var reachedLimit = document.querySelector('.cart__popup_mainn .cart__popup_countt');
                          if (reachedLimit) {
                              reachedLimit.textContent = "You have reached the max quantity limit to add this product.";
                          }
                          if (copyPopup) {
                              setTimeout(function() {
                                  copyPopup.classList.add('copy-code-animation');
      
                                  setTimeout(function() {
                                      copyPopup.classList.remove('copy-code-animation');
                                  }, 3000);
                              }, 1000);
                          }
                      }
                      form.submit();
                  })
                  .catch(error => {
                      console.error('Error fetching cart data:', error);
                  });
          });
      });
      
      
      
      return data;
    }
  );
  

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_WIZZY_API_RESPONDED,
    function (data) {
      // console.log(data," <= AFTER_WIZZY_API_RESPONDED");
      if(data.response){
        if(data.response.payload){
          if(data.response.payload.filters){
            if(data.response.payload.filters.type === "AUTOCOMPLETE_DEFAULT"){
               document.body.classList.add("wizzy-default-autocomplete");
             }
          }
        }
     }

      if(data.response && data.api!=="variation"){
        if(data.response.payload){
          if(data.response.payload.result){
            let payload = data.response.payload.result;
            // console.log(payload)
            payload.forEach(product => {
                  // console.log(product.swatches);
                  if (product.swatches) {
                    // console.log('processing...',product.swatches)
                      if (product.swatches.colors) {
                        // console.log('processing...')
                          if (product.swatches.colors.values.length > 0) {
                            // console.log('processing...')
                              const productId = product.id; // Get the product ID
                              const swatches = product.swatches.colors.values;
                              // console.log(productId,swatches)
              
                              const matchingSwatchIndex = swatches.findIndex(swatch => swatch.variationId === productId);
                              
                              if (matchingSwatchIndex !== -1) {
                                  const matchingSwatch = swatches.splice(matchingSwatchIndex, 1)[0];
                                  swatches.unshift(matchingSwatch); 
                              }
                          }
                      }
                  }
              });
          }
        }
     }
      
      return data;
    }
  );

   window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,function (payload) {
    // console.log(payload," < === BEFORE_AUTOCOMPLETE_EXECUTED")
    payload.sort = [
        {
          "field": "product_value_tags_search_boost",
          "order": "asc"
        },
        {
          "field": "product_wizzyCustomScore_tags:float",
          "order": "desc"
        }
        ]
     payload.showOOSProductsInOrder = "true";
         // console.log(payload.sort," < === BEFORE_AUTOCOMPLETE_EXECUTED")

     // if(payload){
     //   if(payload.q.toLowerCase() === "bitch" || payload.q.toLowerCase() === "bloody" || payload.q.toLowerCase() === "crap"){
     //     payload.q = "abcdefghija";
     //   }
     // }

    const prohibitedWords = ["bitch", "bloody", "crap", "1=1; drop table note", "shit"];
    if (payload && prohibitedWords.includes(payload.q.toLowerCase())) {
        payload.q = "abcdefghija";
    }


    return payload;
    
  })

  window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,function (payload) {
    // console.log(payload," < === BEFORE_SEARCH_EXECUTED")

    if(payload.sort){
      if(payload.sort[0].field === "relevance" && payload.sort.length==1){
        
        payload.sort.unshift ({
            "field": "product_wizzyCustomScore_tags:float",
            "order": "desc"
        });

        payload.sort.unshift ({
            "field": "product_value_tags_search_boost",
            "order": "asc"
        });
        
      }
    }
    payload.showOOSProductsInOrder = "true";
    return payload;
    
  })


  window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.PRODUCTS_RESULTS_RENDERED,function (payload) {
   $(".wizzy-summary-head strong").text($(".wizzy-summary-head strong").text().replace("_"," "))
    function updateButtonInnerHTML(button) {
  button.innerHTML = button.value;
}

// Observer configuration
const observerConfig = { attributes: true, attributeFilter: ['value'] };

// Find all buttons with the specified class name
const buttons = document.querySelectorAll('.wizzy-tocart-button');

// Create a MutationObserver instance for each button
buttons.forEach(button => {
  const observer = new MutationObserver(mutationsList => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'attributes') {
        updateButtonInnerHTML(button);
      }
    }
  });

  observer.observe(button, observerConfig);
  updateButtonInnerHTML(button); // Update initial inner HTML
});
      getCart()  
    return payload;
  })

  window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,function (payload) {
    console.log(payload,"BEFORE_RENDER_RESULTS");
    if(payload.api === "search" || payload.api === "filter"){
        let facets = payload.response.payload.facets;
        facets.forEach((facet)=>{
          let facetdata = facet.data;
          if(Array.isArray(facetdata)){
            facetdata.forEach((facetItem)=>{
              facetItem.label = facetItem.label.replace("_"," ")
            })
          }
        })
    }

    function updateLabels(facet) {
        facet.data.forEach(item => {
            if (item.data && item.data.label) {
                item.data.label = item.label; // Update label with outer label
              // console.log(item);
            }
        });
    }

    if(payload.response){
      if(payload.response.payload){
        if(payload.response.payload.facets){
          payload.response.payload.facets.forEach(facet => {
            if(facet.key === "discountPercentage"){
              
              updateLabels(facet);
              // console.log(facet)
              // if(facet.data){
              //   facet.data.forEach(item => {
              //     console.log(item.label);
              //     if(item.data){
              //       console.log(item.data,' < == wizzy label')
              //     }
              //   })
              // }
            }
          })
        }
      }
    }

    
    // if(payload.api === "search" && payload.response){
    //   if(payload.response.payload.filters){
    //     if(payload.response.payload.filters.q.toLowerCase() === "bitch" || payload.response.payload.filters.q.toLowerCase() === "bloody" || 
    //        payload.response.payload.filters.q.toLowerCase() === "crap"){
    //       payload.error = true;
    //     }
    //   }
    // }

    // Declare the array of prohibited words outside the condition
    const prohibitedWords = ["bitch", "bloody", "crap", "1=1; drop table note", "shit"];
    if (payload.api === "search" && payload.response && payload.response.payload.filters) {
        const filterQuery = payload.response.payload.filters.q.toLowerCase();
        if (prohibitedWords.includes(filterQuery)) {
            payload.error = true;
        }
    }

    
    return payload;
    
  })

    window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (payload) {
     // console.log(payload,"AFTER_PRODUCTS_TRANSFORMED");
      try{
        payload.forEach((item) => {
        if(item?.swatches?.length > 0 && item?.swatches[0]?.values?.length) item.shades = item.swatches[0].values.length
        item.attributes.forEach((attr) => {
          if (attr.id === "product_review_ssw") {
            let reviews = JSON.parse(attr.values[0].value[0])
            if(parseInt(reviews.count) > 0 && parseInt(reviews.avg)){
            item.avgRatings =  parseFloat(reviews.avg);
            item.totalReviews = parseFloat(reviews.count);
            }
          }
          if (attr.id == "product_handle") {
            item.productHandle = attr.values[0].value[0];
          }
          if(attr.id === "product_Badge_tags"){
            item.bagde = attr.values[0].value[0];
            if(item.bagde === "online_early_access") {
              item.bagde = "ONLINE EARLY ACCESS";
          
            }
            // console.log(item.bagde);
          }
        if(attr.id === "product_combo_custom"){
            item.comboPickup = attr.values[0].value[0]
          }
        })

        if(item.price){ 
         item.price = parseInt(item.price.replace(/,/g, ''),10)
        }
        if(item.sellingPrice){
          item.sellingPrice = parseInt(item.sellingPrice.replace(/,/g, ''),10)
        }
        if(item.discount){
           item.discount = parseInt(item.discount.replace(/,/g, ''),10)
        }
        if(item.productHandle.includes("-value-set") || item.productHandle.includes("-duo")){
            item.comboPickup = true
        }
      })
      }catch(error){
        // console.log(error)
      }

      ///////////////////////////////////////////////////

      
        // payload.forEach(product => {
        //       if (product.swatches) {
        //         // console.log('processing...',product.swatches[0])
        //           if (product.swatches[0]) {
        //             // console.log('processing...')
        //               if (product.swatches[0].values.length > 0) {
        //                 // console.log('processing...')
        //                   const productId = product.id; // Get the product ID
        //                   const swatches = product.swatches[0].values;
        //                   // console.log(productId,swatches)
          
        //                   const matchingSwatchIndex = swatches.findIndex(swatch => swatch.variationId === productId);
                          
        //                   if (matchingSwatchIndex !== -1) {
        //                       const matchingSwatch = swatches.splice(matchingSwatchIndex, 1)[0];
        //                       swatches.unshift(matchingSwatch); 
        //                   }
        //               }
        //           }
        //       }
        //   });

      ///////////////////////////////////////////////////


      payload.forEach((product) => {
        product.selectedSwatchValue = "";
        product.validHaxCode = false;
        if(product.swatches){
          const colorData = product.swatches.find(item => item.key === 'colors');
          

          if (colorData && colorData.values.length > 0) {

            var remainCount = colorData.values.length-4;
            
            colorData.values.forEach((item,index) => {
              if(item.isSelected){
                product.selectedSwatchValue = item.value;
              }
              // console.log(item,"wizzy index")
              if(index === 4) item.remainCounts = remainCount;
              let[haxcode,isURLSwatch] = findHaxCode(item.value);
              // console.log(haxcode)
              
              function isValidURL(haxcode) {
                  try {
                      new URL(haxcode);
                      return true;
                  } catch {
                      return false;
                  }
              }
              
              if (isValidURL(haxcode)) {
                product.validHaxCode = true;
              } else {
                product.validHaxCode = false;
              }
              
              item.isSwatch = !0,
              item.isURLSwatch = isURLSwatch,
              item.isVisualSwatch = !0,
              item.swatchValue = haxcode,
              item.data = {
                  value: item.key,
                  swatch: {
                      type: "visual",
                      value: haxcode
                  }
              }
            })

            if (colorData.values.length >= 5) {
              colorData.values = colorData.values.slice(0, 5);
            }
          }
        }
      })

      ////////////////////////////////////////////////////////////////////
      
      return payload;
    }
  );

replaceTemplate("wizzy-search-results-product");
replaceTemplate('wizzy-autocomplete-topproducts');
replaceTemplate('wizzy-search-empty-results');
  replaceTemplate('wizzy-search-empty-results');
replaceTemplate('wizzy-autocomplete-suggestions');
  replaceTemplate('wizzy-search-wrapper');
  // replaceTemplate('wizzy-search-results');

  $("body").on("click", ".autocomplete-link", (e) => {
    let searchedTerm = $(e.target).attr("data-searchterm");
    if (searchedTerm == "serums") {
      e.stopImmediatePropagation();
      window.location.href =
        shopUrlMaker("collections/serums");
    }
    
    if (searchedTerm == "combos") {
      e.stopImmediatePropagation();
      window.location.href = shopUrlMaker("collections/value-sets-combos");
    }
    if (searchedTerm == "lipsticks") {
      e.stopImmediatePropagation();
      window.location.href = shopUrlMaker("collections/lips");
    }
    if (searchedTerm == "new launches") {
      e.stopImmediatePropagation();
      window.location.href = shopUrlMaker("collections/new-launches");
    }
    if (searchedTerm == "best deals") {
      e.stopImmediatePropagation();
      window.location.href = shopUrlMaker("collections/salecampaign");
    }
  });

  
  const shopUrlMaker=(path)=>{
  let urlList=[
    window.location.origin,
    path
  ];
   return urlList.join('/') ;
  }
}


let placeholderText;
if (screen.width >= 768) {
  placeholderText = document.getElementsByClassName("search-input")[0];
}
if (screen.width <= 768) {
  placeholderText = document.getElementsByClassName("mobile_input")[0];
}
var phrases = [
  "Lipstick",
  "Eye Liner",
  "Concealer",
  "Foundation",
  "Blush"
];
let index = 0;
let typingTimer;
function typePhrase() {
  const phrase = phrases[index];
  const len = phrase.length;
  let i = 0;
  typingTimer = setInterval(function () {
    if (i === len) {
      clearInterval(typingTimer);
      setTimeout(erasePhrase, 1000); // Wait for 1 second before erasing
    } else {
      const currentText = placeholderText.getAttribute("placeholder");
      placeholderText.setAttribute(
        "placeholder",
        currentText + phrase.charAt(i)
      );
      i++;
    }
  }, 100); // Change the speed of typing by changing this value
}

function erasePhrase() {
  const currentText = placeholderText.getAttribute("placeholder");
  const len = currentText.length;
  let i = len - 1;
  typingTimer = setInterval(function () {
    if (i === 10) {
      clearInterval(typingTimer);
      index++;
      if (index === phrases.length) {
        index = 0;
      }
      setTimeout(typePhrase, 1000); // Wait for 1 second before typing the next phrase
    } else {
      const newText = currentText.slice(0, i);
      placeholderText.setAttribute("placeholder", newText);
      i--;
    }
  }, 50); // Change the speed of erasing by changing this value
}

  typePhrase();
let wizzyInterval = setInterval(function(){
  if(window?.wizzyConfig?.common?.lazyDOMConfig?.contentDOMIdentifiers){
    clearInterval(wizzyInterval);
    if(window.innerWidth >= 768){
      window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers = [{"dom": ".search-input","type": "search"}]
    }
    else{
      window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers = [{"dom": ".mobile_input","type": "search"}]
    }

    if(window?.wizzyConfig?.common?.isOnCategoryPage){
      window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers =  ["#wizzy-shopify-collection-page-container"]
    }
    else{
      window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers =  ["#main"]
    }
  }
},10)



// Add to cart requirement

// on product result render get the cart and update all the buttons accordingly.


$("body").on("submit",".WizzyProductForm", function(e){
  e.preventDefault();
  let id = $(e.target).find(`button[data-action="add-to-cart"]`).attr("data-var");
  let quantity = parseInt($(e.target).find(`button[data-action="add-to-cart"]`).attr("cartItems"));
  if(quantity >= 5){
    $(e.target).find(".cart-max-limit").css("display","block");
    setTimeout(function(){
      $(e.target).find(".cart-max-limit").css("display","none");
    },5000)
  }
  else{
    let id = $(e.target).find(`button[data-action="add-to-cart"]`).attr("data-var")
    // $(e.target).find(".atc-text").text("adding...")
    $(e.target).find(".atc-text").css("display", "none");
    $(e.target).find(".atc-loader").css("display", "block");
    if ($(e.target).find(".atc-loader").css("display") === "block") {
      $(e.target).find(".cstm_product_grid_atc_button").addClass("new-padding");
    }
    
    makeHttpRequest("/cart/add.js", "POST",{quantity:'1',id:id}, function(data){
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
   bubbles: true
 }));
      $(e.target).find(`button[data-action="add-to-cart"]`).attr("cartItems", quantity+1);
      // $(e.target).find(".atc-text").text("Added.")
      setTimeout(function(){
        // $(e.target).find(".atc-text").text("Add to Cart")
        $(e.target).find(".atc-text").css("display", "block");
        $(e.target).find(".atc-loader").css("display", "none");
        $(e.target).find(".cstm_product_grid_atc_button").removeClass("new-padding");
      },2000)
      setTimeout(function () {
      document.querySelector(".cart__popup_main").style.display =
      "block";
      }, 1500);
      setTimeout(function () {
      document.querySelector(".cart__popup_main").style.display = "none";
      }, 5000);
    })
  }
})



function getCart(){
  makeHttpRequest("/cart.js", "GET", null, function(data){
    data.items.forEach((item)=>{
      $(`.wizzy-result-product[data-id="${item.id}"] button[data-action="add-to-cart"]`).attr("cartItems",item.quantity)
    })
  })
}


async function makeHttpRequest(url, method = 'GET', data = null, onSuccess = null) {
    try {
        const options = {
            method: method,
            headers: {
                'Content-Type': 'application/json', // adjust the content type as needed
            },
        };

        if (data) {
            options.body = JSON.stringify(data);
        }

        const response = await fetch(url, options);

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const responseData = await response.json();

        // Call the success callback if provided
        if (onSuccess && typeof onSuccess === 'function') {
            onSuccess(responseData);
        }

        return responseData;
    } catch (error) {
        // console.error('Error making HTTP request:', error.message);
        throw error;
    }

}